<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="用户审批" left-arrow fixed
                     @click-left="back"/>
                <div class="pay-by">
                    <div class="appr-item">
                        <van-row class="appr-item-head">
                            <van-col span="12" class="appr-item-head-hd">
                                <h5>
                                    <van-icon name="edit"/>
                                    审批信息流
                                </h5>
                            </van-col>
                            <van-col span="12">
                                <p class="item-r"></p>
                            </van-col>
                        </van-row>
                        <van-row>
                            <van-col span="24">
                                <p><span>申请人</span>{{appUser.userName}}</p>
                                <p><span>审批类型</span>{{workFlow.workFlowTypeName}}</p>
                                <p><span>申请时间</span>{{workFlow.createtime}}</p>
                                <p><span>停滞时间</span>{{workFlow.deadTime}}</p>
                            </van-col>
                        </van-row>
                    </div>
                    <div v-for="item in workflowLog">
                        <div class="pay-item ok">
                            <van-row>
                                <van-col span="12">
                                    <p>{{item.createtime}}</p>
                                </van-col>
                                <van-col span="12" class="text-center">
                                    <p>{{item.cost_time}}</p>
                                </van-col>
                            </van-row>
                            <van-row class="pay-item-ft">
                                <van-col span="24">
                                    <p>{{item.remark}}</p>
                                </van-col>
                                <van-col span="24" class="text-right">
                                    <p><span>当前审批：</span>{{item.trueName}}</p>
                                    <p><span>审批状态：</span>{{item.status_name}}</p>
                                </van-col>
                            </van-row>
                            <div class="pay-item-rd"></div>
                        </div>
                    </div>
                </div>
                <van-collapse v-model="activeNames" class="pay-hd-item">
                    <van-collapse-item icon="info-o" title="申请人信息">
                        <van-cell title="用户名" :value="appUser.userName"/>
                        <van-cell title="用户类型" :value="appUser.user_type_name"/>
                        <van-cell title="牧场编号" :value="appUser.pastureID"/>
                        <van-cell title="牧场名称" :value="appUser.mcmc"/>
                        <van-cell title="本月奶价" :value="appUser.milk_price"/>
                        <van-cell title="是否存在贷款" :value="loanName"/>
                        <van-cell title="注册时间" :value="workFlow.createtime"/>
                        <van-cell title="收货地址" :value="appUser.consigneeArea_path"/>
                        <van-cell title="用户手机号" :value="appUser.mobile"/>
                        <van-cell title="所属分公司" :value="appUser.org_name"/>
                        <van-cell title="所属片区" :value="areaName"  @click="areaPop()"/>
                        <van-popup v-model="areaShow" position="bottom" :overlay="true">
                            <van-picker
                                :columns="orgAreas"
                                show-toolbar
                                value-key="org_name"
                                @cancel="areaCancel"
                                @confirm="areaConfirm"
                            />
                        </van-popup>
                        <van-cell title="所属奶牛超市" :value="milkShopName"  @click="milkShopPop()"/>

                        <van-popup v-model="milkShopShow" position="bottom" :overlay="true">
                            <van-picker
                                :columns="orgShops"
                                show-toolbar
                                value-key="org_name"
                                @cancel="milkShopCancel"
                                @confirm="milkShopConfirm"
                            />
                        </van-popup>

                        <van-cell title="所属业务员" :value="businessManName"  @click="businessManPop()"/>
                        <van-popup v-model="businessManShow" position="bottom" :overlay="true">
                            <van-picker
                                :columns="businessMans"
                                show-toolbar
                                value-key="trueName"
                                @cancel="businessManCancel"
                                @confirm="businessManConfirm"
                            />
                        </van-popup>
                        <div v-if="userType!=1">
                        <div class="qiyeBox" v-if="workFlow.currentSquence!=1 && (userRole.indexOf('BM')>-1 || userRole.indexOf('SM')>-1)">
                            <div class="qiye">
                                <div class="label">注册单位</div>
                                <div class="content">
                                    <van-radio-group v-model="regCompany">
                                      <van-radio name="company">企业</van-radio>
                                      <van-radio name="personal">个体</van-radio>
                                    </van-radio-group>
                                </div>
                            </div>
                            <div class="qiye">
                                <div class="label">证件编号</div>
                                <div class="content">
                                    <van-field style="padding: 0;" v-model="infoCode" placeholder="请输入证件号" />
                                </div>
                            </div>
                            <van-uploader :after-read="onRead">
                                <van-field label="证件照片" v-model="accessoryText" readonly placeholder="请选择证件照片" />
                            </van-uploader>
                            <img class="id-img" :src="imgUrl" ref="idImg"/>

                            <van-field
                                v-model="addressPCS"
                                required
                                readonly
                                label="收货地址"
                                placeholder="请选择省/市/区"
                                @focus="addressClick"
                            />
                            <van-popup v-model="addressShow" position="bottom" :overlay="true">
                                <van-picker
                                        :columns="columns"
                                        show-toolbar
                                        value-key="areaName"
                                        @cancel="addressCancel"
                                        @confirm="addressConfirm"
                                        @change="addressChange"
                                />
                            </van-popup>
                            <van-field
                                v-model="address"
                                required
                                label="详细地址"
                                placeholder="街道小区楼牌房间号等信息"
                            />
                            <div class="qiye" >
                                <div class="label">牧场编号</div>
                                <div class="content">
                                    <van-field style="padding: 0;" v-model="pastureId" placeholder="请输入牧场编号" />
                                </div>
                            </div>
                            <div class="qiye">
                                <div class="label">牧场名称</div>
                                <div class="content">
                                    <van-field style="padding: 0;" v-model="pastureName" placeholder="请输入牧场名称" />
                                </div>
                            </div>
                            <div class="qiye">
                                <div class="label">是否大型牧业</div>
                                <div class="content">
                                    <van-radio-group v-model="largeHusbandry">
                                      <van-radio name="0">否</van-radio>
                                      <van-radio name="1">是</van-radio>
                                    </van-radio-group>
                                </div>
                            </div>
                         </div>
                        <p style="text-align: center; padding-top: 15px" v-if="showSaveBtn && actionStatus=='false'"><van-button type="danger" @click="userInfoSave()">保存</van-button></p>
                        </div>
                        <div v-else>
                             <p style="text-align: center; padding-top: 15px" v-if="showSaveBtn && actionStatus=='false'"><van-button type="danger" @click="userInfoSave()">保存</van-button></p>
                        </div>
                    </van-collapse-item>
                    <div class="appr-item apply" v-if="showDealButton && actionStatus=='false'&&rejectStatus==false">
                        <van-row class="appr-item-head">
                            <van-col span="12" class="appr-item-head-hd">
                                <h5>
                                    <van-icon name="edit"/>
                                    审批意见
                                </h5>
                            </van-col>
                            <van-col span="12">
                                <p class="item-r"></p>
                            </van-col>
                        </van-row>
                        <van-row >
                            <van-col span="24" class="textareaBox">
                                <van-field type="textarea" v-model="remark"/>
                            </van-col>
                            <van-col span="8" style="margin-top: 10px">
                                <van-button type="info" size="large" @click="savedeal(1)">通过</van-button>
                            </van-col>
                            <van-col span="8" style="margin-top: 10px">
                                <van-button type="info" size="large" class="danger" @click="savedeal(0)">驳回</van-button>
                            </van-col>
                        </van-row>
                    </div>
                    <div class="appr-item apply" v-if="actionStatus=='false'&&rejectStatus==true">
                         <van-row class="appr-item-head">
                            <van-col span="12" class="appr-item-head-hd">
                                <h5>
                                    <van-icon name="edit"/>
                                    审批意见
                                </h5>
                            </van-col>
                            <van-col span="12">
                                <p class="item-r"></p>
                            </van-col>
                        </van-row>
                        <van-row>
                             <van-col span="24" class="textareaBox">
                                <van-field type="textarea" v-model="remark"/>
                            </van-col>
                        </van-row>
                         <van-row>
                              <van-col span="8" offset="8" style="margin-top: 10px">
                                <van-button type="info" size="large" class="danger" @click="savedeal(0)">确定</van-button>
                            </van-col>
                        </van-row>
                    </div>
                </van-collapse>
    </div>
</template>
<script>
    import {
        NavBar, Cell, CellGroup, Field, Button, Row, Col, Collapse, CollapseItem, Tabs, Tab, Switch, Picker,
        Popup, RadioGroup, Radio, DatetimePicker, Dialog, Uploader
    } from "vant";

    let citys = [];
    let country = {}
    let xjq = {}

    export default {
        name: "ApprovalDetail",
        components: {
            [Dialog.name]: Dialog,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [Switch.name]: Switch,
            [Uploader .name]: Uploader ,
        },
        data() {
            return {
                rejectStatus:false,//驳回状态
                workFlow: {},//审批对象
                appUser:{},//提交用户对象
                workflowLog:[],//流程审批日志
                workflowId:0,//审批编码
                loanName:"否",//是否有贷款
                companyName:'',//分公司名称
                companyId:'',//分公司编码
                areaId:"",//所属片区编号
                areaName:"请选择片区",//所属片区名称
                milkShopId:"",//所属超市编号
                milkShopName:"请选择超市",//所属超市名称
                businessManId:"",//所属业务员编号
                businessManName:"请选择业务员",//所属业务员名称
                businessManIndex:"",//所属业务员索引
                businessMans:[],//业务员列表
                userType:0,//普通用户
                orgAreas:[],//区域列表
                orgShops:[],//奶牛超市列表
                areaShow:false,//片区弹出状态
                milkShopShow:false,//超市弹出状态
                businessManShow:false,//业务员弹出状态
                addressShow:false,
                showSaveBtn:true,//是否展示保存按钮
                remark:"",//审批备注
                largeHusbandry:"0",//是否大型牧业 1是 0否
                regCompany:"personal",//用户类型-personal 个人 company 企业
                infoCode:"",//证件号
                fileCode:"",//证件编号
                imgUrl:"",//证件图片url
                address:"",//收获地址
                pastureId:"",//牧场编号
                pastureName:"",//牧场名称
                addressPCS: "",
                addressAreaId: '',//收货地址编码
                activeNames: ["3"],
                activeName: ["2"],
                accessoryText: '',
                isOpen1: true,
                openText1: "收起",
                openIcon1: "arrow-down",
                showDealButton:false,//是否展示审批按钮
                // 省市区
                popShow: false,
                actionStatus: localStorage.getItem('actionStatus'),
                userRole: localStorage.getItem("userRole"),
                columns: [{
                    values: citys,
                    className: 'column1',
                    defaultIndex: 0
                },{
                    values: country['北京市'],
                    className: 'column2',
                    defaultIndex: 1
                },{
                    values: xjq['北京市'],
                    className: 'column3',
                    defaultIndex: 2
                }],
            };
        },
        mounted() {
            let that = this;
            that.workFlowId=localStorage.getItem("workflow_id");
            that.loadWorkflow();
            that.getAreaList();

        },
        methods: {
            addressClick(){
                this.addressShow=true;
            },
            addressCancel(){
                this.addressShow=false;
            },
            addressConfirm(values){
                this.addressShow=false;
                this.addressPCS = values[0].areaName + ' ' + values[1].areaName + ' ' + values[2].areaName;
                this.addressAreaId = values[2].id
            },
            //用户信息保存
            userInfoSave(){
                let that=this;
                let currentSquence=that.workFlow.currentSquence;
                if(currentSquence ==1 && !that.checkBadminUserInfoParam()){
                    return;
                }
                if((currentSquence==2 || currentSquence ==3)&&  !that.checkBmUserInfoParam()){
                    return;
                }
                if(currentSquence==1){
                that.$api.post(that.jumuc.userCenter.bAdminFlowUpdateUserInfo,{
                    userId:that.appUser.id,
                    orgCompany:that.companyId,
                    orgArea:that.areaId,
                    orgMilkShop:that.milkShopId,
                    businessManId:that.businessManId
                },res=>{
                    if(res.success){
                        that.showSaveBtn=false;
                    }
                })
                }else if(currentSquence==2 || currentSquence==3){
                    that.$api.post(that.jumuc.userCenter.bmUpdateUserInfo,
                        {
                        userId:that.appUser.id,
                        regCompany: that.regCompany,
                        infoCode:that.infoCode,
                        fileCode:that.fileCode,
                        address:that.address,
                        pastureId:that.pastureId,
                        pastureName: that.pastureName,
                        largeHusbandry: that.largeHusbandry,
                        areaId:that.addressAreaId
                        },res => {
                            if(res.success){
                                that.showSaveBtn=false;
                            }
                        });
                }
            },
            checkBadminUserInfoParam(){
                let that=this;


                    if(!that.businessManId){
                        Dialog.alert({
                            message:"所属业务员不能为空"
                        });
                        return false;
                    }
                    if(!that.areaId){
                        Dialog.alert({
                            message:"所属片区不能为空"
                        });
                        return false;
                    }
                    if(!that.milkShopId){
                        Dialog.alert({
                            message:"所属超市不能为空"
                        });
                        return false;
                    }
                    return true;

            },
            checkBmUserInfoParam(){ //Bm更新用户信息
                let that=this;
                if(!that.infoCode){
                    Dialog.alert({
                        message:"身份证号不能为空"
                    });
                    return false;
                }
                if(!that.pastureId){
                    Dialog.alert({
                        message:"牧场编号不能为空"
                    });
                    return false;
                }
                if(!that.pastureName){
                    Dialog.alert({
                        message:"牧场名称不能为空"
                    });
                    return false;
                }
                if(!that.addressAreaId){
                    Dialog.alert({
                        message:"收货地址省市区不能为空"
                    });
                    return false;
                }
                if(!that.address){
                    Dialog.alert({
                        message:"收货详细地址不能为空"
                    });
                    return false;
                }
                if(!that.fileCode||that.fileCode==-1){
                    Dialog.alert({
                        message:"证件图片不能为空"
                    });
                    return false;
                }
                return true;
            },
            //加载流程信息
            loadWorkflow(){
                let that = this;
                that.$api.post(that.jumuc.userCenter.selAuditedDetailInfo,{'workFlowId':that.workFlowId,'flag':true},res => {
                    if(res && res.success){
                        let workflow=res.data.workFlow;
                        that.workFlow=workflow
                        if(res.data.appUser.register_unit==1){
                            that.regCompany='personal'
                        }else{
                              that.regCompany='company'
                        }
                        that.workflowLog=res.data.workflowLog;
                        var arr = res.data.workflowLog.filter(function (x) {
                            return x.status==false;
                        })
                        //确定按钮的判断
                        if(this.userRole.indexOf('BM')!=-1&&workflow.status==0){
                            this.rejectStatus=false;
                        }
                        this.rejectStatus=arr.length>0?true:false;
                        that.loadAppUserInfo(workflow,res.data.appUser,res.data);
                        that.upImgUrl = res.data.upImgUrl;
                        that.showDealButton=(res.data.isAdminAudit || res.data.isBmAudit || res.data.isSmAudit )?true:false;
                    }
                })
            },
            //加载分公司及片区/所属奶牛超市/所属业务员信息
            loadAppUserInfo(workflow,appUser,data){
                let that=this;
                that.appUser=appUser;
                //判断是否存在贷款
                if(appUser.isLoan==null || appUser.isLoan==false){
                    that.loanName='否';
                }else{
                    that.loanName='是';
                }
                //加载选中分公司
                that.companyName=appUser.org_name;
                that.companyId=appUser.org_company_id;
                //加载选中片区和选中业务员和选中超市
                if(workflow.currentSquence!=1 || appUser.org_area_id!=null){
                    that.areaId=appUser.org_area_id;
                    that.areaName=appUser.org_area;
                    that.businessManId=appUser.businessMan_id;
                    that.businessManName=appUser.businessMan;//所属业务员
                    that.userType=appUser.user_type;//用户类型 1非签约 2签约 0普通
                    that.milkShopId=appUser.org_milk_shop_id;
                    that.milkShopName=appUser.org_milk_shop;
                    that.addressPCS=appUser.area_path;//省市区地址
                    that.addressAreaId=appUser.area_id;//省市区地址编码
                    that.infoCode=appUser.idCard;
                    that.fileCode=appUser.idCard_image;
                    that.imgUrl=appUser.idCard_image_url;
                    that.address=appUser.address;
                    that.pastureId=appUser.pastureID;
                    that.pastureName=appUser.mcmc;
                    //that.showSaveBtn=true; 
                    // 
                    if(this.userType==1){//非签约
                      
                       if(workflow.currentSquence==1){
                            that.showSaveBtn=true;
                      }else{
                           that.showSaveBtn=false;
                      }    
                    }else{
                      if((workflow.currentSquence==2 && !appUser.area_id)||(workflow.currentSquence==3 && data.isSmAudit) ){
                           that.showSaveBtn=true;
                        }else{
                            that.showSaveBtn=false;
                        }
                    }
                    
                }

                that.loadAreaAndShopInfo();
            },
            loadAreaAndShopInfo(){
                let that = this;
                that.$api.get(that.jumuc.userCenter.queryAreaAndShop,{'org_company_id':that.companyId},res => {
                    if(res && res.success){
                        that.businessMans=res.data.businessMans;
                        that.orgAreas=res.data.org_areas;
                        that.orgShops=res.data.org_shops;
                        if(!that.areaId){
                            that.areaId=that.orgAreas[0].id;
                            that.areaName=that.orgAreas[0].org_name;
                            that.businessManId=that.businessMans[0].id;
                            that.businessManName=that.businessMans[0].trueName;
                            that.milkShopId=that.orgShops[0].id;
                            that.milkShopName=that.orgShops[0].org_name;
                        }

                    }
                })
            },
            areaCancel() {
                this.areaShow = false;
            },
            areaConfirm(values) {
                let that = this
                that.areaId = values.id;
                that.areaName = values.org_name;
                that.areaShow = false;
            },
            areaPop() {
                let that = this;
               // if(this.userType!=1){
                    that.areaShow = that.workFlow.currentSquence==1;
               // }
               
            },
            milkShopCancel() {
                this.milkShopShow = false;
            },
            milkShopConfirm(values) {
                let that = this
                that.milkShopId=values.id;
                that.milkShopName=values.org_name;
                this.milkShopShow = false;
            },
            milkShopPop() {
                let that = this;
                if(this.userType!=1){
                     that.milkShopShow = that.workFlow.currentSquence==1;
                }
            },

            businessManCancel() {
                this.businessManShow = false;
            },
            businessManConfirm(values) {
                let that = this
                this.businessManId = values.id;
                this.businessManName=values.trueName;
                this.businessManShow = false;
            },
            businessManPop() {//选择所属业务员
                let that = this;
                //if(this.userType!=1){//不是非签约的时候 可选
                   that.businessManShow = that.workFlow.currentSquence==1;
               // }
            },
            back() {
                history.back();
            },
            showOpen1(i) {
                this.isOpen1 = !this.isOpen1;
                this.openText1 = this.isOpen1 ? '收起' : '展开';
                this.openIcon1 = this.isOpen1 ? 'arrow-up' : 'arrow-down';
            },
            showPop() {
                this.popShow = true;
            },
            onPickerCancel() {
                this.popShow = false;
            },
            addressChange(picker, values, defaultIndex) {
                let ss
                let that = this
                if (defaultIndex == 0) {
                    that.$api.post(
                        that.jumuc.userCenter.areaList,
                        {"parent_id": values[0].id},
                        successRes => {
                            ss = successRes.data[0].areaName
                            country[values[0].areaName] = successRes.data
                            that.$api.post(
                                that.jumuc.userCenter.areaList,
                                {"parent_id": successRes.data[0].id},
                                successRes => {
                                    xjq[ss] = successRes.data
                                    that.columns = [
                                        {
                                            values: citys,
                                            className: 'column1',
                                            defaultIndex: 0
                                        },
                                        {
                                            values: country[values[0].areaName],
                                            className: 'column2',
                                            defaultIndex: 1
                                        }
                                        ,
                                        {
                                            values: xjq[ss],
                                            className: 'column3',
                                            defaultIndex: 2
                                        }
                                    ]
                                    picker.setColumnValues(1, country [values[0].areaName]);
                                    picker.setColumnValues(2, xjq [values[1].areaName]);
                                })
                        })
                }
                if (defaultIndex == 1) {
                    that.$api.post(
                        that.jumuc.userCenter.areaList,
                        {"parent_id": values[1].id},
                        successRes => {
                            xjq[ss] = successRes.data
                            that.columns = [
                                {
                                    values: citys,
                                    className: 'column1',
                                    defaultIndex: 0
                                },
                                {
                                    values: country[values[0].areaName],
                                    className: 'column2',
                                    defaultIndex: 1
                                }
                                ,
                                {
                                    values: xjq[ss],
                                    className: 'column3',
                                    defaultIndex: 2
                                }
                            ]
                            picker.setColumnValues(2, xjq [values[1].areaName]);
                        })
                }
            },
            getAreaList(id) {
                let that = this
                let aa
                let ss
                //省
                that.$api.post(
                    that.jumuc.userCenter.areaList,

                    {"parent_id": id},
                    successRes => {
                        citys = successRes.data
                        aa = successRes.data[0].areaName
                        //市
                        that.$api.post(
                            that.jumuc.userCenter.areaList,
                            {"parent_id": citys[0].id},
                            successRes => {
                                country[citys[0].areaName] = successRes.data
                                ss = successRes.data[0].areaName
                                //县/区
                                that.$api.post(
                                    that.jumuc.userCenter.areaList,
                                    {"parent_id": successRes.data[0].id},
                                    successRes => {
                                        xjq[ss] = successRes.data
                                        that.columns = [
                                            {
                                                values: citys,
                                                className: 'column1',
                                                defaultIndex: 0
                                            },
                                            {
                                                values: country[aa],
                                                className: 'column2',
                                                defaultIndex: 1
                                            }
                                            ,
                                            {
                                                values: xjq[ss],
                                                className: 'column3',
                                                defaultIndex: 2
                                            }
                                        ]
                                    })
                            })
                    })
            },
            savedeal(status){
                let that=this;
                if(status==0 && !that.remark){
                    Dialog.alert({
                        message:"驳回内容不能为空"
                    });
                    return;
                }else{
                    //if(this.userType!=1){
                        if(that.showSaveBtn){
                        Dialog.alert({
                            message:"用户信息未保存"
                        });
                        return;
                    }
                   // }
                }

                that.$api.post(that.jumuc.stock.savedeal,{workflowId:that.workFlowId,currentSquence:that.workFlow.currentSquence,status:status,remark:that.remark},res =>{
                    Dialog.alert({
                        message:res.msg
                    }).then(() => {
                        history.go(-1)
                   });
                })
            },
            onRead(file) {
                 let that = this;
                let forms = new FormData()
                if(that.regCompany=="personal"){
                    forms.append("imageType","file");
                    forms.append("file",file.file);

                }else{
                    forms.append("imageType","businessLicenceImage");
                    forms.append("businessLicenceImage",file.file);
                }

                that.$api.upload(that.upImgUrl,forms,res => {
                    if(res.data.result){
                        that.fileCode=res.data.data.id;
                        that.accessoryText=res.data.data.imgName;
                        that.imgUrl = res.data.data.imgUrl;
                    }
                })

            },
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3C6EEB;

    body {
        background: #f7f7ff;
    }

    .appr-tabs {
        .van-tab {
            color: #fff;
        }
        .van-tabs__nav {
            background-color: @bule-thame;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
    }

    .jump-warphd {

        .van-icon {
            color: @bule-thame;
        }
        .appr-item {
            padding: 10px;
            margin-bottom: 10px;
            background-color: #fff;
            h5 {
                font-size: 16px;
                padding-bottom: 10px;
                i {
                    padding: 5px;
                    background-color: @bule-thame;
                    color: #fff;
                    border-radius: 100%;
                    margin-right: 5px;
                }
            }
            p {
                padding: 4px 0;
                font-size: 14px;
                &.item-r {
                    color: #ccc;
                    text-align: right;
                }
                span {
                    min-width: 60px;
                    display: inline-block;
                    margin-right: 5px;
                }
            }
            &-head {
                border-bottom: 1px #f7f7f7 solid;
                &-hd {
                    position: relative;
                }
            }
            &-foot {
                border-top: 1px #f7f7f7 solid;
                p {
                    color: #ccc
                }
            }
            .item-arrow {
                border-top: 1px solid #f7f7f7;
                text-align: center;
                color: @bule-thame;
            }
            .line {
                display: block;

            }
        }

        .pro-body {
            padding: 10px;
            .pro-item {
                margin-bottom: 10px;
                background-color: #fff;
                padding: 10px;
                h5 {
                    font-size: 14px;
                    padding-bottom: 10px;

                }
                span {
                    min-width: 60px;
                    display: inline-block;
                    margin-right: 5px;
                }
                p {
                    font-size: 14px;
                    padding: 10px 0;
                }
                &-by {
                    padding: 10px 0 0;
                }
                &-ft {
                    background-color: #f7f7f7;
                    padding: 10px;
                }
                .pro-edit {
                    color: @bule-thame;
                    text-decoration: underline;
                    i {
                        vertical-align: -2px;
                    }
                }
            }
        }
        .pay-by {
            padding: 10px;
            .pay-item {
                background-color: #fff;
                padding: 10px;
                position: relative;
                margin-bottom: 10px;
                p {
                    color: #ccc;
                    font-size: 12px;
                    padding: 5px 0;
                }
                &-ft {
                    padding-top: 10px;
                    p {
                        color: #333;
                    }
                }
                .pay-state {
                    text-align: right;
                    color: @bule-thame;
                    i {
                        display: inline-block;
                        padding: 5px;
                        border-radius: 100%;
                        background-color: @bule-thame;
                    }
                }
                &-rd {
                    position: absolute;
                    top: 0;
                    left: -5px;
                    width: 10px;
                    height: 100%;
                    background-color: @bule-thame;
                    border-radius: 10px 0 0 10px;
                }

                &.ok {
                    .pay-state {
                        color: #28a745;
                        i {
                            background-color: #28a745;
                        }
                    }
                    .pay-item-rd {
                        background-color: #28a745;
                    }
                }
                &.err {
                    .pay-state {
                        color: #ffc107;
                        i {
                            background-color: #ffc107;
                        }
                    }
                    .pay-item-rd {
                        background-color: #ffc107;
                    }
                }
            }
        }
        .pay-hd-item {
            margin-bottom: 10px;
            .pay-hd-line {

                margin-bottom: 10px;
            }

        }

        .van-cell:not(:last-child)::after {
            border: none;
        }

        .apply {
            .van-field {
                margin: 10px 0;
                border: 1px solid #f7f7f7;
            }
            .van-col--8 {
                padding: 0 10px;
            }
            button {
                font-size: 14px;
                height: 40px;
                line-height: 38px;
                background-color: @bule-thame;
                border-color: @bule-thame;
            }
            button.danger {
                background-color: #ffc107;
                border-color: #ffc107;
            }
        }

        .item-body-warp {
            height: 60px;
            overflow: hidden;
            position: relative;
        }
        .item-body-warp.open {
            height: auto;
        }
    }
    .van-field__control {
        text-align: right;
    }

    .qiyeBox {
        .qiye {
            padding: 10px 15px;
            .label {
                display: inline-block;
                color: #323233;
                font-size: 14px;
                line-height: 24px;
            }
            .content {
                display: inline-block;
                float: right;
                input[type="file"] {
                    width: 200px;
                }
                .van-field {
                    border: 0;
                }
                .van-radio-group {
                    .van-radio {
                        display: inline-block;
                        margin-left: 20px;
                        i.van-icon {
                            color: #fff;
                        }
                    }
                }
            }
        }
        .van-uploader {
            width: 100%;
        }
    }
    .apply {
        .textareaBox {
            .van-field {
                .van-field__body {
                    .van-field__control {
                        text-align: left;
                    }
                }
            }
        }
    }
    .id-img{
        width: 95%;
        height: 180px;
    }
</style>
